import React from 'react';
import DashboardSidebar from '../components/DashboardComponents/DashboardSidebar';

import AdminTestimonialCreateForm from '../components/AdminComponents/AdminTestimonialCreateForm';
import InnerBanner from '../components/PagesComponents/InnerBanner';
const AdminTestimonialCreate = () => {
 return (
    <>
    <InnerBanner pageKey="adminTestimonialCreate" />
      <section className='profile-sec py-5'>
        <div className='container'>
            <div className='row'>
                <div className='col-lg-9'>
                     <AdminTestimonialCreateForm/>
                </div>
                <div className='col-lg-3'>
                    <DashboardSidebar/>
                </div>
            </div>
        </div>
      </section>
    </>
 );

};

export default AdminTestimonialCreate;
